// src/utils/sendNotification.js
export async function sendNotification(targetUser, title, body) {
    console.log("before",targetUser)
  try {
    //https://artika-last-120889172969.europe-west1.run.app for prod
    //http://localhost:8080 for localtest
    const response = await fetch("http://localhost:8080/send-to-user", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        uid: targetUser, // اسم المستخدم مثل designer@123
        title,
        body,
      }),
    });
console.log("after",targetUser)
    const result = await response.json();
    console.log("✅ إشعار أُرسل إلى:", targetUser, result);
  } catch (error) {
    console.error("❌ فشل إرسال الإشعار:", error);
  }
}
